import { createAction } from 'redux-actions'

export const setOtpSecret = createAction('SET_OPT_SECRET')

export default { setOtpSecret }
